import type { FaireProductEntity } from "../../entity_types/product";

export const p_kkfwtxybt6: FaireProductEntity = {
  token: "p_kkfwtxybt6",
  type: "product",
  name: "The Classic Tale of Peter Rabbit Board Book: Revised Ed",
  brandToken: "b_mkqgf4yzct",
  brandName: "HarperCollins Focus",
  imageUrl:
    "https://cdn.faire.com/fastly/bf83035fecdcc4393b0c177be6a7b69b012d044398ca056ac9332a118847c22c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ebb81d873e74139fef0434a0e8242a6f4392f88b4d2dd62d51603d21eb9d995.jpeg",
    "https://cdn.faire.com/fastly/4d82d0d39513ab04072fac506f3f54d88f84abd4f8fc0e8dfc9003772c69c928.jpeg",
    "https://cdn.faire.com/fastly/fabd3b3d2693f9aab63a5aef63866948284d7e04abd2b3eff1c914875ca289a8.jpeg",
    "https://cdn.faire.com/fastly/9e13ed030aa5985a4efe2c3127c4ffa4a19df8ed8c7f04455c2b8965650fec4e.jpeg",
    "https://cdn.faire.com/fastly/848a75ab199ea972fbadaff6555ba24113908a8b7462741f51af67bdf33802e7.jpeg",
    "https://cdn.faire.com/fastly/7728c3d724ac963808832f982c22eea70675db64eea56b07b12be4d752a0b4be.jpeg",
    "https://cdn.faire.com/fastly/2a9fe50824507c8388f3e84f437013449aa8d3f38f63991f4c5198345cba2630.jpeg",
    "https://cdn.faire.com/fastly/75ea643a610c8fdf123cb282815440170b8fc1b86b837cd40d7248d6f5f1d49f.jpeg",
    "https://cdn.faire.com/fastly/1c697473ea9851086707150b083cae505a79c9e136b803dcf532e043c8583bd5.jpeg",
  ],
  priceDollars: 4.48,
  description:
    "Board Book\nJoin the world's most beloved bunny, Peter Rabbit, in this board book version of the childhood classic perfect for an Easter basket or the spring season.\n\nThis board book with sturdy pages and rounded corners is perfect for toddlers, who will enjoy entering Beatrix Potter’s enchanted world full of rabbits and bunnies. Charles Santore illustrates this timeless tale with lessons in values, morals, and virtue.\n\nBoy and girls will delight in this abridged version made for the smallest of readers as they cuddle up for story time.",
  tags: [],
  msrpDollars: 8.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:08.653Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
